(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/oddset-kambi/components/kambi-widget-utils/assets/javascripts/build-filter.js') >= 0) return;  svs.modules.push('/modules/oddset-kambi/components/kambi-widget-utils/assets/javascripts/build-filter.js');
"use strict";


function joinWithParenthesis(stringsArray) {
  let innerParenthesis = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  if (stringsArray.length === 0) {
    return '';
  } else if (stringsArray.length === 1) {
    return stringsArray[0];
  }
  if (innerParenthesis) {
    return stringsArray.map(item => "(".concat(item, ")")).join('|');
  }
  return "(".concat(stringsArray.join('|'), ")");
}
function buildFilterRecursively(filter) {
  if (Array.isArray(filter)) {
    return joinWithParenthesis(filter, false);
  }
  const subFilters = [];
  Object.keys(filter).forEach(key => {
    subFilters.push("".concat(key, "/").concat(buildFilterRecursively(filter[key])));
  });
  return joinWithParenthesis(subFilters, true);
}


function buildFilter(filter) {
  return "/".concat(buildFilterRecursively(filter));
}
if (svs.isServer) {
  module.exports = buildFilter;
} else {
  setGlobal('svs.oddset_kambi.components.kambiWidgetUtils.buildFilter', buildFilter);
}

 })(window);